/**
 * Custom Link format that overrides the existing link format
 * https://github.com/zenoamaro/react-quill#custom-formats
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Kelvin Nguyen
 */
import { Quill } from 'react-quill'
import { trackEvent } from 'client/shared/js/utils/tracking'

const Link = Quill.import('formats/link')

/**
 * Extends the Quill Link format and adds an event listener to track link clicks
 */
class CustomLink extends Link {
  static create (value) {
    const node = super.create(value)

    node.addEventListener('click', (evt) => {
      evt.stopPropagation()

      trackEvent('Notes Url Clicked', {
        'URL': value
      })
    })

    return node
  }
}

export default CustomLink
